export default "__VITE_ASSET__YRhehR87__"